import { Component, OnInit } from '@angular/core';
import { PluginManagerService } from '../../../service/plugin-manager.service';

@Component({
  selector: 'app-taskbar',
  templateUrl: './taskbar.component.html',
  styleUrls: ['./taskbar.component.scss']
})
export class TaskbarComponent implements OnInit {

  constructor ( public pluginManager: PluginManagerService ) { }

  appController:any = null;

  ngOnInit() {
    this.appController = this.pluginManager.appController;
  }

  removeApp ( app:any = null ) {
    if ( app ) {
      this.appController.delete ( app.name );
    }
  }
}
